// update state
const setActionRefreshDashboard = (payload) => {
    return {
        type: "ACTIONREFRESHDASHBOARD",
        payload
    }
}

export default setActionRefreshDashboard;


// WEBPACK FOOTER //
// ./src/actions/setActionRefreshDashboard.js